import { RequestMiddleware, ResponseMiddleware } from 'src/api/types'
import config from 'src/constants/config'

class ServiceBase {
  public get baseURL() {
    return config.API_URL
  }

  protected requestMiddleware: RequestMiddleware[] = []
  protected responseMiddleware: ResponseMiddleware[] = []

  public addRequestMiddleware(...middleware: RequestMiddleware[]) {
    this.requestMiddleware.push(...middleware)
  }

  public addResponseMiddleware(...middleware: ResponseMiddleware[]) {
    this.responseMiddleware.push(...middleware)
  }
}

export default ServiceBase
